import { type CommonProps, ONBOARDING_EVENTS, trackEvent } from "."

export const courses = {
  removeEvent: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.REMOVE_COURSE_EVENT, props),
}
